import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  lottieOptions: any = {
    ticketconfirm: {path: '../../assets/loaders/ticketconfirm.json'},
    loading: {path: '../../assets/financia-anim.json'}
  };

  constructor() { }

  ngOnInit(): void {
  }

}
